<template>
    <div class="container side-by-side">
        <div class="row">
            <search-area class="col-12"></search-area>
        </div>
        <div class="row search-loading__parent">
            <search-categories class="col-4"></search-categories>
            <search-results class="col-8"></search-results>
        </div>
    </div>
</template>

<script>
    import SearchArea from "../components/search-area/search-area.vue";
    import SearchCategories from "../components/search-categories/search-categories.vue";
    import SearchResults from "../components/search-results/search-results.vue";

    export default {
        name: "side-by-side",
        props: {

        },
        components: {SearchCategories, SearchArea, SearchResults}
    }
</script>
